var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('body',[_c('div',{staticClass:"tutor_mobile"},[_c('img',{attrs:{"src":_vm.complete_mobile}})]),_c('div',{staticClass:"tutor_wrap",style:({ background: 'url(\'' + _vm.complete_pc + '\') no-repeat center top' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }